module.exports = __webpack_public_path__ + "img/matsuyama_PF用photo.25929fc8.png";